var _style, _polygon, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLiveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.3 80.7",
    style: {
      enableBackground: "new 0 0 130.3 80.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D61118;}\n\t.st1{fill:#911010;}\n\t.st2{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.3,68.2 130.3,0 0,0 0,68.2 55.8,68.2 55.8,74.5 43.5,74.5 43.5,80.7 86.9,80.7 86.9,74.5  74.5,74.5 74.5,68.2 "
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_live") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 6.1,
    className: "st1",
    width: 118,
    height: 55.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.1,18.3 19.8,18.3 19.8,49.8 40.9,49.8 40.9,45.2 25.1,45.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 18.3,
    className: "st2",
    width: 5.3,
    height: 31.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.6,40.8c-0.5,1.2-0.9,2.3-1.3,3.5c-0.4-1.1-0.8-2.3-1.2-3.5l-8.5-22.5h-5.7l12.9,31.6h5l13-31.6h-5.4 L70.6,40.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "92.7,45.2 92.7,35.8 110.5,35.8 110.5,31.2 92.7,31.2 92.7,22.9 111.7,22.9 111.7,18.3 87.4,18.3  87.4,49.8 112.4,49.8 112.4,45.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveRed);
export default __webpack_public_path__ + "static/media/Icon_live_red.90b7f80879e44177016866eaf4b75919.svg";
export { ForwardRef as ReactComponent };